export const PHOTO_COUNT_TO_SHOW = 6;

export const ASPECT_RATIO = {
  desktop: '12/7',
  mobile: '1/1',
};
